/**
 * Terms & Conditions Page
 *
 * CMS-managed legal page with hardcoded fallback content.
 */

import { LegalPage } from '@/components/LegalPage';
import { DEFAULT_TERMS } from '../defaults/termsDefaults';

export const TermsPage = () => (
    <LegalPage
        pageSlug="terms"
        title="Terms & Conditions"
        metaDescription="Terms and Conditions for Stork Rentals baby equipment rental service."
        defaults={DEFAULT_TERMS}
    />
);

export default TermsPage;
